import { $api } from '../y/api';
import { $http } from '../y/http';

export function fIconsUploadFile(file: File, progress?: (p: number) => void) {
    return $http.POST(`/api/v1/page_icons`, file, { up_progress: progress }).catch($api.errorHandler);
}

